// Ashe — Crystal Arrow: fires a massive enchanted arrow that stuns the frontmost
// enemy for 2 turns. Enemies behind it take reduced damage with no stun.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const asheVolley: Ability = {
  id: "asheVolley",
  displayName: "Crystal Arrow",
  description: "Fires a stunning arrow. The frontmost enemy takes 1.2× AD + 60 physical damage and is stunned for 2 turns. All other enemies take 0.5× AD.",
  iconId: "AsheR",

  targetShape({ combat, caster }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(enemyTeam).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam).sort((a, b) => a.pos.q - b.pos.q);
    if (enemies.length === 0) return [];
    const stats = effectiveStats(caster);
    const hits: AbilityHit[] = [];

    const primary = enemies[0];
    hits.push({
      target: primary,
      amount: physicalDamage(stats.ad * 1.2 + 60),
      type: "physical",
      effect: { kind: "stun", duration: 2 },
    });

    for (const e of enemies.slice(1)) {
      hits.push({
        target: e,
        amount: physicalDamage(stats.ad * 0.5),
        type: "physical",
        suppressPopup: true,
      });
    }

    return hits;
  },
};
